(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/hooks/use-account-balance.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/hooks/use-account-balance.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const svsUtilsformatCurrency = svs.utils.format.Currency;
const accountSelector = svs.numbergames.accountSelector;
const showTeamErrorDialog = text => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Hoppsan!',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showTeamNotActiveMemberProlongErrorDialog = () => showTeamErrorDialog('Du vill förlänga ett lagspel där du inte längre är medlem. Vi ändrar så du betalar från ditt eget spelkonto.');
const useAccountBalance = (syndicateId, isSyndicate) => {
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    accountBalance = _useState2[0],
    setAccountBalance = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isInitialised = _useState4[0],
    setIsInitialised = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    accountIsSyndicate = _useState6[0],
    setAccountIsSyndicate = _useState6[1];
  useEffect(() => {
    const getAccountBalance = async () => {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        var _response, _response2;
        let response;
        if (syndicateId && isSyndicate) {
          try {
            response = await accountSelector.setActiveAccount(syndicateId);
          } catch (e) {
            showTeamNotActiveMemberProlongErrorDialog();
            response = await accountSelector.usePlayerAccount();
          }
        } else {
          response = await accountSelector.usePlayerAccount();
        }
        setAccountIsSyndicate((_response = response) === null || _response === void 0 ? void 0 : _response.isSyndicate);
        setAccountBalance(svsUtilsformatCurrency((_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.balance));
      } else {
        setAccountIsSyndicate(syndicateId && isSyndicate);
      }
      setIsInitialised(true);
    };
    getAccountBalance();
    return () => {
      accountSelector.usePlayerAccount();
    };
  }, [isSyndicate, syndicateId]);
  return {
    accountBalance,
    isInitialised,
    accountIsSyndicate
  };
};
setGlobal('svs.numbergames.prolong_game.hooks.useAccountBalance', useAccountBalance);

 })(window);